"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function sleepAsync(duration, cancellationToken) {
    return duration
        ? new Promise(function (resolve) {
            // declare unregister here so it is defined in the callback if the register callback is invoked synchronously (the token is already canceled)
            var unregister;
            var unregisterAndResolve = function () {
                clearTimeout(timeoutId);
                if (unregister) {
                    unregister();
                }
                resolve();
            };
            var timeoutId = setTimeout(unregisterAndResolve, duration);
            unregister = cancellationToken ? cancellationToken.register(unregisterAndResolve) : null;
        })
        : Promise.resolve();
}
exports.sleepAsync = sleepAsync;
